import Icon from '@ant-design/icons';
import {
  notificationCategories,
  notificationTypesWithAvatar,
} from 'utils/notification';
import { Common } from '@stockbit/ui';
import { CustomAvatar } from 'global/Header/Search/options';
import { LightningSvg } from 'features/day-trade/components/Icons';
import Image from 'global/Image';
import { IconContainer, DayTradeWrapper } from './styled';

const { Avatar, Iconmoon } = Common;

interface NotificationItemImageProps {
  type: string;
  avatar?: string;
}

function NotificationItemImage({ type, avatar }: NotificationItemImageProps) {
  if (notificationTypesWithAvatar.includes(type)) {
    return <CustomAvatar img={avatar} name="avatar" />;
  }

  if (notificationCategories.reports.includes(type)) {
    return (
      <Avatar size="x-small" className="panel-avatar">
        <Iconmoon as="a" size="20px" className="icon-avatar_report" />
      </Avatar>
    );
  }

  if (notificationCategories.tipping.includes(type)) {
    return (
      <IconContainer>
        <Image src={avatar} width="30" height="30" alt="tipping" />
      </IconContainer>
    );
  }

  if (notificationCategories.tradingMatchOrder.includes(type)) {
    return (
      <Avatar size="small">
        <Iconmoon as="a" size="30px" className="icon-avatar_order" />
      </Avatar>
    );
  }

  if (notificationCategories.trending.includes(type)) {
    return (
      <Image
        src="/icon/notification-trending.svg"
        width="30"
        height="30"
        alt="trending"
      />
    );
  }

  if (notificationCategories.verified.includes(type)) {
    return (
      <Image
        src="/icon/notification-approved.png"
        width="30"
        height="30"
        alt="approved"
      />
    );
  }

  if (notificationCategories.dayTrade.includes(type)) {
    return (
      <DayTradeWrapper>
        <Icon component={LightningSvg} />
      </DayTradeWrapper>
    );
  }

  return (
    <Avatar size="small">
      <Iconmoon as="a" size="30px" className="icon-panel_notification" />
    </Avatar>
  );
}

export default NotificationItemImage;
